import { createMemoryHistory, createBrowserHistory } from 'history'

const isTests = process.env.NODE_ENV === 'test' || process.env.TS_JEST === '1'
export const history = isTests ? createMemoryHistory() : createBrowserHistory()